import React, { forwardRef, ReactNode } from 'react';
import styled from 'styled-components';
import { BasicEntity } from '../EntityLabels';
import { overflowingStyles } from '../../styles/shareableStyles';

interface IProps {
  children: ReactNode;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  disabled?: boolean;
  showClearAction?: boolean;
  isManaged?: boolean;
}

const StyledBasicEntity = styled(BasicEntity)`
  position: relative;
  max-width: 264px;
  font-size: 10px;
  font-weight: 500;
  line-height: 16px;
  user-select: none;
  white-space: break-spaces;
  display: block;
  ${overflowingStyles};
`;

const Category = forwardRef<HTMLDivElement, IProps>(
  ({ children, onClick, disabled, showClearAction, isManaged }, ref) => {
    return (
      <StyledBasicEntity
        ref={ref}
        variant={isManaged ? 'dark-blue' : 'grey'}
        onClear={showClearAction && onClick ? onClick : undefined}
        isDisabled={disabled}
      >
        {children}
      </StyledBasicEntity>
    );
  },
);

export default Category;
